"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _ramda = require("ramda");

var _input = _interopRequireDefault(require("../input-component/input"));

var _element = _interopRequireDefault(require("../form-ui/element"));

var _utils = require("../../utils");

var _dayPicker = _interopRequireDefault(require("./day-picker"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var DateFormElement = (0, _styledComponents["default"])(_element["default"]).withConfig({
  displayName: "date-picker__DateFormElement",
  componentId: "sc-ym5gdl-0"
})(["min-width:187px;"]);
var propTypes = {
  /** Label for the input field */
  bottomLabel: _propTypes.node,

  /** A boolean to represent whether the input field should be disabled */
  disabled: _propTypes.bool,

  /** A boolean to represent whether the input field has a status of error */
  error: _propTypes.bool,

  /** Glyph node */
  glyphLeft: _propTypes.node,

  /** String for input field id */
  id: _propTypes.string,

  /** Label for the input field */
  label: _propTypes.node,

  /** onBlur event handler - used to process the event */
  onBlur: _propTypes.func,

  /** onDayClick event handler - used to process the clicking on calendar dates */
  onDayClick: _propTypes.func,

  /** onFocus event handler - used to process the event */
  onFocus: _propTypes.func,

  /** Placeholder text to show while input is empty */
  placeholder: _propTypes.string,

  /** A boolean to represent whether the input field should be validated */
  required: _propTypes.bool,

  /** A boolean to represent whether the input field has a status of success */
  success: _propTypes.bool,

  /** Label for the input field */
  topLabel: _propTypes.node,

  /** Value for the date picker - managed outside the component */
  value: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number, _propTypes.object])
};
var defaultProps = {
  glyphLeft: "calendar"
};

var DatePickerComponent = function DatePickerComponent(props) {
  var disabled = props.disabled,
      glyphLeft = props.glyphLeft,
      id = props.id,
      label = props.label,
      onBlur = props.onBlur,
      onDayClick = props.onDayClick,
      onFocus = props.onFocus,
      placeholder = props.placeholder,
      required = props.required,
      value = props.value;

  var _useCallbackRef = (0, _utils.useCallbackRef)(null, ["dayPicker"]),
      datePicker = _useCallbackRef[0],
      datePickerRef = _useCallbackRef[1];

  var _useFocus = (0, _utils.useFocus)(false, onBlur, onFocus, {
    target: datePicker
  }),
      hasFocus = _useFocus[0],
      handleBlur = _useFocus[1],
      handleFocus = _useFocus[2];

  var handleDayClick = (0, _react.useCallback)(function (e) {
    return (0, _utils.callIfFunc)(onDayClick, e);
  }, [onDayClick]);
  var hasLabel = label && label.length > 0;
  var showValue = !label || hasFocus || (0, _ramda.is)(Date, value);
  var dayString = (0, _ramda.is)(Date, value) && value.getMonth() + 1 + "/" + value.getDate() + "/" + value.getFullYear();
  return /*#__PURE__*/_react["default"].createElement(DateFormElement, _extends({
    dropDown: hasFocus ? /*#__PURE__*/_react["default"].createElement(_dayPicker["default"], _extends({
      backgroundColor: "background",
      onBlur: handleBlur,
      onDayClick: handleDayClick,
      onFocus: handleFocus,
      ref: datePickerRef,
      selectedDays: [value],
      showOutsideDays: true,
      width: 300
    }, props)) : null,
    glyphLeft: glyphLeft,
    glyphRight: "caret-down",
    hasFocus: hasFocus,
    showValue: showValue
  }, props), /*#__PURE__*/_react["default"].createElement(_input["default"], {
    disabled: disabled,
    fieldId: id,
    handleBlur: handleBlur,
    handleFocus: handleFocus,
    hasLabel: hasLabel,
    placeholder: placeholder,
    readOnly: true,
    required: required,
    showValue: showValue,
    type: "text",
    value: dayString || ""
  }));
};

DatePickerComponent.propTypes = propTypes;
DatePickerComponent.defaultProps = defaultProps;
DatePickerComponent.displayName = "Modules.DatePickerComponent";
var _default = DatePickerComponent;
exports["default"] = _default;